import { Action } from './action';

export class ContinueAsGuest extends Action {
}

export class LeaveGuestMode extends Action {
}

export class EnterNonJetPortalMode extends Action {
}
